import { apiClient } from './apiClient';


export const loginUser = async (data): Promise<any> => {
  try {
    const response = await apiClient.post<any>('/api/auth/login', data);
    return response.data;
  } catch (error: unknown) {

    throw error;
  }
};
